import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage2(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(refs.texts.hello.current, { scale: 0.7, alpha: 0, duration: 2 }, 'stage2').to(
    refs.circle.current,
    { scale: 1.8, backgroundColor: 'rgba(255, 255, 255, 0)', duration: 2 },
    'stage2'
  );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage2',
    animations: [
      { x: vw(-0.044), y: vh(-0.126), duration: 2 },
      { x: vw(0.18), y: vh(-0.09), duration: 2 },
      { x: vw(0.27), y: vh(0.019), duration: 2 },
      { x: vw(0.11), y: vh(0.116), duration: 2 },
      { x: vw(-0.135), y: vh(0.094), duration: 2 },
      { x: vw(-0.233), y: vh(-0.025), duration: 2 },
    ],
  });
}
